import { frontendURL } from '../../../helper/URLHelper';
import TicketsView from './TicketsView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/tickets'),
      name: 'support_tickets_list',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: TicketsView,
      props: () => ({ ticketId: 0 }),
    },
    {
      path: frontendURL('accounts/:accountId/tickets/:ticketId'),
      name: 'support_ticket_show',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: TicketsView,
      props: route => ({
        ticketId: Number(route.params.ticketId),
      }),
    },
  ],
};
